var exports = {
  "Qz": "issueTypeTokenContainer__5d1zt1",
  "pA": "tokenText__e1Ghm-",
  "Cz": "customLink__cnTVFT",
  "Sh": "token__mtfHBU",
  "x6": "button__OlRzkp",
};

module.exports = exports;
